import {
	blackColors,
	defaultFont,
	hexToRgb,
	primaryColor,
	whiteColor,
	backgroundColor,
	dangerColor,
} from 'assets/jss/material-dashboard-pro-react';

const icon = {
	'& svg': {
		position: 'relative',
		marginRight: 2,
		top: 3,
		height: 16,
		width: 16,
		color: blackColors[4],
	},
};

const topupStyle = (theme) => ({
	numberTag: {
		width: 100,
	},
	customNumber: {
		width: '100px',
		display: 'inline-block',
		marginRight: 4,
	},
	customNumberInput: {
		position: 'relative',
	},
	customNumberLoader: {
		position: 'absolute',
		width: '100%',
		top: 12,
		zIndex: 2,
	},
	customNumbersContainer: {
		'& > div': {
			display: 'inline-block',
		},
		'& > div:first-of-type': {
			width: '288px',
			maxWidth: '75%',
		},
		'& > div:nth-of-type(2)': {
			width: '25%',
		},
	},
	allNumbers: {
		marginTop: 3,
	},
	addCustomNumber: {
		paddingTop: 20,
	},
	dialogBody: {
		borderTop: `1px solid ${blackColors[6]}`,
		paddingTop: 8,
		paddingBottom: 50,
	},
	topUpDialogValue: {
		marginTop: 18,
		marginBottom: 22,
		lineHeight: '40px',
		fontFamily: theme.fontFamily.alvar.bold,
		'& > p': {
			display: 'inline-block',
			marginBottom: 0,
		},
		'& > p:first-child': {
			fontSize: '34px',
		},
		'& > p:nth-child(2)': {
			fontSize: '23px',
			marginLeft: 5,
		},
	},
	paymentRejected: {
		marginTop: 36,
	},
	payAgainButton: {
		width: '100%',
	},
	seePayments: {
		whiteSpace: 'pre-line',
	},
	editValue: {
		width: '200px',
		height: '152px',
		borderRadius: 4,
		position: 'absolute',
		top: -32,
		right: 10,
		overflow: 'unset',
		zIndex: 1200,
		padding: 16,
	},
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
	},
	selectedItemIcon: {
		height: 24,
		width: 24,
		marginRight: 8,
	},
	numberAmount: {
		margin: 'auto 0',
		[theme.browser.IE]: {
			display: 'flex',
			alignItems: 'center',
		},
	},
	numbersPhone: {
		height: 16,
		width: 16,
		color: blackColors[4],
		marginRight: 8,
		position: 'relative',
		top: 3,
	},
	phone: {
		...icon,
	},
	departmentName: {
		display: 'flex',
		alignItems: 'center',
		'& svg': {
			marginRight: 8,
		},
	},
	editIcon: {
		color: primaryColor[0],
		margin: '0 3px 0 0',
	},
	departmentIcon: {
		width: 32,
		height: 32,
		borderRadius: 4,
		padding: 10,
		color: whiteColor,
	},
	login: {
		...icon,
	},
	cellCaption: {
		margin: '5px 6px 0 6px',
	},
	userCaption: {
		marginLeft: 24,
	},
	departmentBadge: {
		marginTop: theme.direction === 'rtl' ? 0 : 3,
	},
	editButtons: {
		display: 'flex',
		justifyContent: 'space-between',
		'& button': {
			margin: 0,
		},
	},
	wrapper: {
		backgroundColor: whiteColor,
		borderRadius: 4,
	},
	addNumbersWrapper: {
		textAlign: 'center',
		paddingTop: 96,
		paddingBottom: 118,
	},
	emptyDonations: {
		height: '275',
	},
	paymentLoading: {
		padding: '229px 0',
	},
	donationTabWrapper: {
		padding: '24px 0 0 24px',
		textAlign: 'left',
		[theme.breakpoints.only('xs')]: {
			paddingLeft: 0,
		},
	},
	donationTabHeader: {
		[theme.breakpoints.only('xs')]: {
			paddingLeft: 30,
		},
	},
	tableWrapper: {
		height: '100%',
		position: 'relative',
	},
	manyNumbersEdit: {
		position: 'absolute',
		top: 'calc(50% + 76px)',
		left: 'calc(50% + 100px)',
	},
	donationWrapper: {
		backgroundColor: backgroundColor[0],
		width: 'calc(100% + 24px)',
		position: 'relative',
		left: -24,
		marginTop: 40,
		[theme.breakpoints.only('xs')]: {
			width: '100%',
		},
		[theme.breakpoints.up('sm')]: {
			'& > div': {
				width: '80%',
				margin: '0 auto',
			},
		},
	},
	donationsButtons: {
		textAlign: 'right',
		paddingRight: 32,
		paddingTop: 16,
		paddingBottom: 32,
		'& > div': {
			minWidth: 100,
			display: 'inline-block',
			width: '17%',
		},
	},
	icon: {
		marginBottom: 56,
	},
	addNumbersButton: {
		marginTop: 56,
	},
	addNumbersDialog: {
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 28,
			paddingRight: 28,
		},
		[theme.breakpoints.up('sm')]: {
			paddingLeft: 56,
			paddingRight: 56,
		},
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 6,
			paddingRight: 6,
		},
	},
	filterBy: {
		padding: 0,
	},
	topupCard: {
		width: '100%',
		marginBottom: 24,
	},
	topupCardHeader: {
		width: '100%',
		display: 'flex',
		marginLeft: 12,
		marginBottom: 37,
	},
	topupValueContainer: {
		display: 'flex',
		textAlign: 'center',
	},
	customInput: {
		paddingTop: 0,
		margin: '0 0 0 auto',
		'& input': {
			...defaultFont,
			fontSize: 18,
			lineHeight: '24px',
			textAlign: 'right',
			padding: '10px 8px 6px',
		},
	},
	refreshValueIcon: {
		color: primaryColor[0],
		margin: 12,
		height: 16,
		width: 16,
		cursor: 'pointer',
	},
	customTopUpInput: {
		width: '60%',
		marginTop: 5,
		'& p': {
			textAlign: 'right !important',
		},
	},
	editInput: {
		paddingRight: 2,
	},
	marginValue: {
		marginTop: theme.direction === 'rtl' ? 12 : 18,
	},
	totalAmountValue: {
		...defaultFont,
		fontSize: 17,
		lineHeight: '24px',
		fontWeight: 'bold',
	},
	totalAmountCurrency: {
		...defaultFont,
		fontSize: 12,
		lineHeight: '24px',
		fontWeight: 'bold',
	},
	alignRight: {
		textAlign: 'right',
	},
	topupButtonContainer: {
		display: 'inline-block',
		marginLeft: 'auto',
	},
	tableFooter: {
		backgroundColor: 'white',
		marginTop: 1,
		width: '100%',
		padding: '28px 38px 32px 0',
	},
	headerContainer: {
		'& > div:nth-of-type(2)': {
			textAlign: 'center',
		},
		[theme.breakpoints.down('sm')]: {
			'& > div > div': {
				justifyContent: 'center',
			},
			'& > div > p': {
				textAlign: 'center',
			},
		},
	},
	selectedRow: {
		background: `linear-gradient(${blackColors[6]}, ${blackColors[6]}), linear-gradient(white, white)`,
	},
	editedRow: {
		background: `linear-gradient(rgba(${hexToRgb(primaryColor[0])}, 0.06), rgba(${hexToRgb(
			primaryColor[0]
		)}, 0.06)), linear-gradient(white, white)`,
	},
	accountPicker: {
		marginTop: 8,
		paddingTop: 9,
		marginBottom: 24,
		backgroundColor: whiteColor,
		'& .MuiInputBase-root': {
			paddingLeft: 17,
		},
		width: '288px',
		maxWidth: '75%',
	},
	noDepartments: {
		height: 370,
		paddingTop: 114,
	},
	editCell: {
		overflow: 'visible!important',
	},
	editCellIcon: {
		position: 'absolute',
		right: 2,
		top: 2,
		zIndex: 10,
	},
	paymentRejectedBody: {
		marginBottom: 60,
	},
	topUpCardIcon: {
		height: 80,
		[theme.breakpoints.down('sm')]: {
			height: 75,
		},
	},
	editCellInputWrapper: {
		display: 'flex',
		alignItems: 'center',
		paddingBottom: 16,
		paddingTop: 28,
	},
	singleTopupValueWrapper: {
		'& button': {
			height: 48,
			minWidth: 48,
			marginRight: 8,
			marginLeft: 0,
			fontSize: theme.fontSize(28),
		},
	},
	divider: {
		display: 'inline-flex',
		width: '33.96px',
		height: '0px',
		margin: '0 -8px',
		borderBottom: '1.6px solid rgba(0, 0, 0, 0.85)',
		transform: 'rotate(103.63deg)',
		position: 'relative',
		top: '20px',
	},
	creditLimitContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'baseline',
	},
	totalAmountContainer: {
		display: 'flex',
		'& > p:first-of-type': {
			textAlign: 'left',
		},
		alignItems: 'center',
	},
	dangerColor: {
		'& > p': {
			color: dangerColor[0],
		},
		'& > div': {
			borderColor: dangerColor[0],
		},
		'& > div:last-of-type p': {
			color: dangerColor[0],
		},
	},
});

export default topupStyle;
